import React from 'react';


const JournalLanding = () => {
  return (
    <div className="max-w-4xl mx-auto px-5 py-10 min-h-screen bg-gradient-to-br from-pink-50 via-orange-50 to-yellow-50">

      <div className="text-center mb-12">
        <h1 className="text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-pink-500 to-rose-400 bg-clip-text text-transparent mb-5">
          ✨ Hi Friend! ✨
        </h1>
        <p className="text-xl md:text-2xl text-purple-800 font-medium">
          Welcome to the cosiest way to journal 💌
        </p>
      </div>


      <div className="bg-white rounded-3xl p-8 mb-8 shadow-lg">
        <h2 className="text-rose-400 text-3xl font-bold mb-5">
          What's journaling anyways tho? 📖
        </h2>
        <p className="text-gray-700 leading-relaxed text-lg mb-4">
          Journaling is like having a conversation with yourself!! It's the practice of 
          writing down your thoughts, feelings, experiences, and reflections. This includes but isn't limited to: daily adventures, creative ideas, or just how you're feeling.
        </p>
        <p className="text-gray-700 leading-relaxed text-lg mb-3">
          It can help you:
        </p>
        <ul className="text-gray-700 leading-loose text-lg space-y-2">
          <li>✨ Process your emotions and reduce stress</li>
          <li>🎯 Track your goals and celebrate progress</li>
          <li>💭 Remember important moments you'd otherwise forget</li>
          <li>🌱 Understand yourself better over time</li>
          <li>🎨 Express creativity without judgment... i dont save any info btw, in fact it doesnt get stored at all!!</li>
        </ul>
      </div>


      <div className="bg-white rounded-3xl p-8 mb-8 shadow-lg">
        <h2 className="text-rose-400 text-3xl font-bold mb-5">
          But OH NO IM SO SLEEPYYY!! and my desk is....all the way over there...
        </h2>
        <p className="text-gray-700 leading-relaxed text-lg mb-4">
          Traditional journaling can feel like a chore. You need to remember to write, 
          find your notebook, make it look pretty (Because whats the point if you dont?????...) 
          and tbh? Sometimes you just forget or don't have the energy, or mostly dont have the energy. Time is finite so its best we dont waste it. And with all the attention centered world we live it can be hard to remember what we did last week let alone what you ate for Lunch.
        </p>
        <p className="text-gray-700 leading-relaxed text-lg font-semibold">
          What if journaling could be as easy as sending an email? GASP I KNOW, RIGHT??? 💡
        </p>
      </div>

   
      <div className="bg-gradient-to-br from-pink-50 to-rose-100 rounded-3xl p-10 mb-8 shadow-xl border-2 border-pink-200">
        <h2 className="text-rose-400 text-4xl font-bold mb-8 text-center">
          How it works ✨
        </h2>
        
        <div className="grid gap-5">
          <div className="bg-white p-6 rounded-2xl border-2 border-pink-200">
            <h3 className="text-pink-500 text-xl font-bold mb-3">
              1️⃣ Write your thoughts
            </h3>
            <p className="text-purple-900 leading-relaxed">
              Just type whatever's on your mind, even fanfic is chill!!
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl border-2 border-pink-200">
            <h3 className="text-pink-500 text-xl font-bold mb-3">
              2️⃣ Pick your vibe
            </h3>
            <p className="text-purple-900 leading-relaxed mb-3">
              Choose a style (or your own) that matches your vibe for the day:
            </p>
            <div className="flex flex-wrap gap-2 text-sm">
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                🌸 Plain
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                ⚔️ Medieval
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                👼 Angelic
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                ☕ Cozy
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                💕 Cozy Pink
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                🌙 Night Cozy
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                🔥 Aggressive
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                💙 Sad
              </span>
              <span className="bg-white px-4 py-2 rounded-full border border-pink-300">
                🌈 Super Happy
              </span>
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl border-2 border-pink-200">
            <h3 className="text-pink-500 text-xl font-bold mb-3">
              3️⃣ Send it to yourself!
            </h3>
            <p className="text-purple-900 leading-relaxed">
              I'll email your journal entry to you with cool styling. 
              No notebooks needed, no decorating stress. Just pure journaling vibes 
              delivered right to your inbox! 💌
            </p>
          </div>
        </div>
      </div>

  
      <div className="bg-white rounded-3xl p-8 mb-8 shadow-lg">
        <h2 className="text-rose-400 text-3xl font-bold mb-5">
          Why you'll probably love this 💖
        </h2>
        <ul className="text-gray-700 leading-loose text-lg space-y-2 list-none pl-0">
          <li>📧 All your entries saved in your email so you can easily look back.. searchable & organised</li>
          <li>🎨 Beautiful styling without the manual effort YAYYY</li>
          <li>📱 Journal from anywhere - phone, computer, wherever!!</li>
          <li>🕐 Takes literally 2 minutes OR LESS!!</li>
          <li>✨ No physical journal to lose or forget!!</li>
          <li>🌈 Match the aesthetic to your mood every single time!!</li>
        </ul>
      </div>

      <div className="text-center mt-12">
        <button className="bg-gradient-to-r from-pink-500 to-rose-400 text-white px-12 py-4 text-xl font-semibold rounded-full shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-200">
          Start Journaling ✨
        </button>
        <p className="mt-5 text-gray-400 text-sm">
          No signup needed!! just start writing!
        </p>
      </div>
    </div>
  );
};

export default JournalLanding;